import {AdditionalCustomerType} from '@dms/api/sales';

export const CHECKOUT_ADDITIONAL_CUSTOMER_DEFAULT_ROLE: AdditionalCustomerType = 'operator';
